import React, { useEffect, useState, useMemo } from 'react';
import { useHistory } from 'react-router-dom';

import moment from 'moment';

import Accordion from '../../../../components/Accordion';
import Select from '../../../../components/Inputs/Select';
import Input from '../../../../components/Inputs/Input';
import StepProgress from '../../../../components/StepProgress';
import Datepicker from '../../../../components/Inputs/DatepickerMui';
import PageLoader from '../../../../components/PageLoader';
import Alert from '../../../../components/Alert';
import Divider from '../../../../components/Divider';
import DependentsDetails from '../../../../components/Cards/DependentsDetails';
import Modal from '../../../../components/Modal';
import Button from '../../../../components/Button';
import FormContainer from '../../../../components/FormContainer';

import steps from '../../../../utils/steps.json';
import { cloneObject, handleTopCritics, addMaskCpf, checkIsSupport } from '../../../../utils';
import validate from '../../../../utils/validateForm';
import validators from '../../../../utils/defaultValidators';

import schema from './schema';

import {
    // getContratosPorGrupo,
    buscaBeneficiarioTransferenciaFamilia,
    transferirBeneficiario,
    getStates,
    getCities,
    getCongenerByContractAndPlanAndUfAndCity,
    buscaDadosPorContrato,
} from '../../../../services';
import { getCongenerByContractAndPlan } from '../../../../services/v3/contrato-congenere';

import { useGlobal } from '../../../../contexts/Global/context';

import { PageContainer, ContainerButton } from '../../../../styles/styles';

function mapCostCenter(contract) {
    return contract.centrosCusto.map((costCenter) => ({
        codigo: costCenter.codigoLocalTS,
        nome: costCenter.nomeLocalTrabalho,
    }));
}

function Beneficiario({ location: { dataBeneficiario, criticas } }) {
    const history = useHistory();

    const { dataActiveContract, setShowSupportModal, contractsGroupsList } = useGlobal();

    const [alerts, setAlerts] = useState([]);
    // eslint-disable-next-line no-unused-vars
    const [treatedResponseGrupoContratos, setTreatedResponseGrupoContratos] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [modalMessage, setModalMessage] = useState('');
    const [modalInfo, setModalInfo] = useState({});
    const [loadingPost, setLoadingPost] = useState(false);
    const [dataForm, setDataForm] = useState(criticas ? dataBeneficiario : cloneObject(schema));
    const [dataMovimentacao, setDataMovimentacao] = useState({});
    const [beneficiario, setBeneficiario] = useState({});
    const [dataContrato, setDataContrato] = useState({});
    const [alreadyChangedTransferDate, setAlreadyChangedTransferDate] = useState(false);
    const [suggestedTransferDate, setSuggertedTransferDate] = useState(false);
    const [dataCongener, setDataCongener] = useState({});
    const [allowedPlans, setAllowedPlans] = useState({
        dependente: false,
        agregado: false,
    });
    const [pageLoading, setPageLoading] = useState(false);
    const [congenerContract, setCongenerContract] = useState([]);

    useEffect(() => {
        if (criticas != null) {
            setAlerts([...criticas]);
        };
    }, []);

    const residencial = useMemo(
        () =>
            dataBeneficiario?.enderecos?.length > 0
                ? dataBeneficiario?.enderecos.find((endereco) => endereco.eResidencial)
                : {},
        [dataBeneficiario?.enderecos]
    );

    function mapStateOptions(results) {
        return results.map(({ descricaoUf, idUf }) => ({
            codigo: idUf,
            nome: descricaoUf,
        }));
    }

    function mapCityOptions(results) {
        return results.map(({ descricaoMunicipio, idMunicipio }) => ({
            codigo: idMunicipio,
            nome: descricaoMunicipio,
        }));
    }

    async function getCongenereStates(numeroContrato, codigoPlano) {
        const { results } = await getCongenerByContractAndPlan({ numeroContrato, codigoPlano });
        setCongenerContract(results);

        const states = new Set();

        await Promise.all(
            results.map(async ({ numeroContratoCongenere }) => {
                const { congenere } = await getStates({ idContratoCongenere: numeroContratoCongenere });
                if (congenere?.estados) {
                    congenere.estados.forEach((estado) => {
                        states.add(JSON.stringify(estado));
                    });
                }
            })
        );
        return Array.from(states)
            .map((state) => JSON.parse(state))
            .flat();
    }

    async function getCongenereCities(idUf) {
        if (!congenerContract) return [];

        const cities = new Set();

        await Promise.all(
            congenerContract.map(async ({ numeroContratoCongenere }) => {
                const { congenere } = await getCities({ idContratoCongenere: numeroContratoCongenere, idUf });
                if (congenere?.municipios) {
                    congenere.municipios.forEach((municipio) => {
                        cities.add(JSON.stringify(municipio));
                    });
                }
            })
        );
        return Array.from(cities)
            .map((city) => JSON.parse(city))
            .flat();
    }

    function checkTransferDate(form) {
        if (
            moment(form.dataTransferencia.value).format('YYYY-MM-DD') <
            moment(new Date().toISOString()).format('YYYY-MM-DD')
        ) {
            form.dataTransferencia.error = 'Data selecionada não pode ser inferior à data atual';
        }

        if (dataContrato?.dataInicioVigencia && dataContrato?.dataFimVigencia) {
            const isBetweenVigencia = moment(form.dataTransferencia.value).isBetween(
                moment(dataContrato?.dataInicioVigencia).format('YYYY-MM-DD'),
                moment(dataContrato?.dataFimVigencia).format('YYYY-MM-DD'),
                undefined, // Parametro de ano, dia, nao utlizado
                '[]' // considerar dataInicioVigencia igual ao valor comparado, e nao apenas maior
            );

            if (!isBetweenVigencia) {
                form.dataTransferencia.error =
                    'Data selecionada não pode ser anterior ou posterior a data de vigência do contrato';
            }
        }
    }

    function handleInputBlur(event) {
        const { id, name, value } = event.target;
        const key = id || name;

        const form = cloneObject(dataForm);

        // Valida as regras de negocio do campo e, caso haja erro, altera o indice error
        if (typeof validators[key] === 'function') validators[key](form);

        if (id === 'dataTransferencia' && value) {
            checkTransferDate(form);
        }

        // Valida as regras de negocio do campo e, caso haja erro, altera o indice error
        if (typeof validators[key] === 'function') validators[key](form);

        // Valida os campos obrigatorios sem valores
        if (form[key].required && !value) {
            form[key].error = form[key].requiredMessage || 'Preencha com um valor válido.';
        }

        setDataForm({ ...form });
    }

    async function handleChangeInput(event) {
        const { id, value, unmaskedValue, lookup } = event;

        const field = { ...dataForm[id], value, lookup, unmaskedValue, error: '' };

        let dynamicFields = {};

        const getStateOptions = async (contrato, plano) => {
            const stateOptions = await getCongenereStates(contrato, plano);

            dynamicFields = {
                ...dynamicFields,
                state: {
                    ...dataForm.state,
                    value: '',
                    options: mapStateOptions(stateOptions),
                },
                city: {
                    ...dataForm.city,
                    options: [],
                    value: '',
                },
            };
        };

        if (id === 'novoContrato') {
            const responseNovoContrato = await buscaDadosPorContrato(value);
            const novoContratoData = responseNovoContrato.results[0];


            if(novoContratoData.codigoTipoProduto === 2){
                setShowModal(true);

                setModalMessage(
                    'Atenção, identificamos que o contrato selecionado é odontológico, por gentileza selecionar código vinculado ao saúde.'
                );

                return;
            }

            const plansOptions = novoContratoData.planos
                .filter(({ dataFimValidade }) => {
                    const isFutureDate = moment(dataFimValidade) >= moment();

                    return !dataFimValidade || isFutureDate;
                })
                .map((plan) => ({ ...plan, nome: `${plan.codigoPlano} - ${plan.nomePlano}` , value: plan.codigoPlano, codigo: plan.codigoPlano, label: `${plan.codigoPlano} - ${plan.nomePlano}`}));

            const locationsOptions = novoContratoData.lotacoes
                .map((location) => ({ ...location, nome: `${location.nomeLotacao}` , value: location.codigoLotacao, codigo: location.codigoLotacao, label: `${location.nomeLotacao}`}));

            dynamicFields = {
                ...dynamicFields,
                novaLotacao: {
                    ...dataForm.novaLotacao,
                    value: '',
                    options: locationsOptions,
                },
                novoPlano: {
                    ...dataForm.novoPlano,
                    options: plansOptions,
                    value: '',
                },
                novoCentroCusto: {
                    ...dataForm.novoCentroCusto,
                    value: '',
                    options: mapCostCenter(novoContratoData),
                },
                novaMatricula: {
                    ...dataForm.novaMatricula,
                    required: novoContratoData.parametros[0]?.obrigatorioInformarMatriculaFuncional,
                },
            };

            if (value && dataForm.novoPlano?.value) await getStateOptions(value, dataForm.novoPlano.value);

            if (beneficiario.dependentes.length > 0) {
                const hasDependentes =
                    beneficiario.dependentes.filter((dependente) => dependente.tipo === 'DEPENDENTE').length > 0 &&
                    !!event.permitePlanoDifDependente;
                const hasAgregados =
                    beneficiario.dependentes.filter((dependente) => dependente.tipo !== 'DEPENDENTE').length > 0 &&
                    !!event.permitePlanoDifAgregado;

                dynamicFields = {
                    ...dynamicFields,
                    novoPlanoDependente: {
                        ...dataForm.novoPlanoDependente,
                        required: hasDependentes,
                        options: plansOptions,
                    },
                    novoPlanoAgregado: {
                        ...dataForm.novoPlanoAgregado,
                        required: hasAgregados,
                        options: plansOptions,
                    },
                };

                setAllowedPlans({
                    ...allowedPlans,
                    dependente: hasDependentes,
                    agregado: hasAgregados,
                });
            }

            if (event.situacao === 'I') {
                setModalInfo({
                    title: 'Atenção!',
                    message: 'Não é permitido a transferência de beneficiário para contratos inativos.',
                    backButton: true,
                });

                setShowModal(true);

                return;
            }
        }

        if (id === 'state') {
            const municipios = value ? await getCongenereCities(value) : [];

            dynamicFields = {
                ...dynamicFields,
                city: { ...dataForm.city, value: '', options: mapCityOptions(municipios) },
            };
        }

        // Ao trocar o plano do titular, altera o valor do plano agregado e dependente
        if (id === 'novoPlano') {
            if (value && dataForm.novoContrato?.value) await getStateOptions(dataForm.novoContrato.value, value);

            dynamicFields = {
                ...dynamicFields,
                novoPlanoDependente: {
                    ...dataForm.novoPlanoDependente,
                    value: field.value,
                },
                novoPlanoAgregado: {
                    ...dataForm.novoPlanoAgregado,
                    value: field.value,
                },
            };
        }

        if (id === 'dataTransferencia' && beneficiario.dataTransferencia !== value) {
            if (!alreadyChangedTransferDate) {
                setModalInfo({
                    title: 'Tem certeza que quer alterar a data de transferência deste plano?',
                    message:
                        'Essa alteração gera custo integral na próxima fatura, já que a data de transferência proposta pelo sistema está ligada à data dos vencimentos da sua empresa.',
                });

                setAlreadyChangedTransferDate(true);
                setShowModal(true);
            }
        }

        setDataForm({
            ...dataForm,
            ...dynamicFields,
            [id]: field,
        });
    }

    async function handleSendTransferencia() {
        setLoadingPost(true);

        const { validatedForm, isValid } = validate(dataForm);

        checkTransferDate(validatedForm);

        setDataForm({
            ...dataForm,
            ...validatedForm,
        });

        if (!isValid) {
            setTimeout(() => {
                const firstElementWithError = document.querySelector('.error');

                if (firstElementWithError)
                    firstElementWithError.scrollIntoView({
                        block: 'center',
                        behavior: 'smooth',
                    });
            }, 100);

            setLoadingPost(false);

            return;
        }

        if (checkIsSupport()) {
            setShowSupportModal(true);
            return;
        }

        const transferBody = {
            ...dataMovimentacao,
            numeroContrato: dataContrato.numero.toString(),
            codigoTS: beneficiario.codigoTs,
            numeroAssociadoOuNumeroCarteira: beneficiario.carteirinha,
            tipoAssociado: beneficiario.tipo[0],
            dataTransferencia: dataForm.dataTransferencia?.value,
            numeroContratoNovo: dataForm.novoContrato?.value,
            codigoLotacao: dataForm.novaLotacao?.value,
            codigoLocalTrabalho: dataForm.novoCentroCusto?.value,
            codigoPlanoTitular: dataForm.novoPlano?.value,
            codigoPlanoDependente: allowedPlans.dependente
                ? dataForm.novoPlano?.value
                : dataForm.novoPlanoDependente?.value,
            codigoPlanoAgregado: allowedPlans.dependente
                ? dataForm.novoPlano?.value
                : dataForm.novoPlanoAgregado?.value,
            numeroMatriculaEmpresa: dataForm.novaMatricula?.value,
            codigoMunicipio: dataForm.city.value,
            referenciaMovimentacao: dataActiveContract.referenciaMovimentacao?.dataReferenciaMovimentacao,
        };

        const respTransferencia = await transferirBeneficiario(transferBody);

        const movimentacao = respTransferencia.movimentacoes[0];
        const criticasTratadas = handleTopCritics(movimentacao?.criticas);

        if (criticasTratadas.length > 0) {
            setAlerts([...criticasTratadas]);

            setDataMovimentacao({
                sequencialMovimentacao: movimentacao.sequencialMovimentacao,
                codigoSituacaoMovimentacao: movimentacao.codigoSituacaoMovimentacao,
            });

            setTimeout(() => {
                window.document.getElementById('page-content').scrollTo(0, 0);
            }, 100);

            setLoadingPost(false);

            return;
        }

        history.push('/movimentacao_cadastral/validar_transferencia_beneficiario');

        setLoadingPost(false);
    }

    async function updateCongenerName() {
        const { results } =
            (await getCongenerByContractAndPlanAndUfAndCity({
                numeroContrato: dataForm?.novoContrato.value,
                codigoPlano: dataForm?.novoPlano?.value,
                siglaUf: dataForm?.state?.value,
                codigoMunicipio: dataForm?.city?.value,
            })) || [];

        const [{ nomeFantasiaCongenere }] = results?.length ? results : [{ nomeFantasiaCongenere: '' }];

        setDataCongener({ ...dataCongener, new: nomeFantasiaCongenere });
    }

    useEffect(() => {
        setDataCongener({ ...dataCongener, new: '' });

        if (dataForm.state.value && dataForm.city.value && dataForm.novoPlano.value) updateCongenerName();
    }, [dataForm.state.value, dataForm.city.value, dataForm.novoPlano.value]);

    useEffect(() => {
        if (!dataBeneficiario) history.push('/movimentacao_cadastral/selecionar_transferencia_beneficiario');

        async function loadDataBeneficiario() {
            setPageLoading(true);

            const { numero: numeroContrato, codGrupoEmpresa, referenciaMovimentacao } = dataActiveContract;

            const responseBeneficiarioTransferencia =
                (await buscaBeneficiarioTransferenciaFamilia(dataBeneficiario?.carteirinha, numeroContrato)) || {};

            // const responseGrupoContratos = (await getContratosPorGrupo(codGrupoEmpresa)) || [];
            
            let responseGrupoContratos = contractsGroupsList.find((x) => (x.idGrupoContrato.toString() === (codGrupoEmpresa)));

            responseGrupoContratos = responseGrupoContratos.contratos
                .map((element) => ({
                    codigo: element.numeroContrato,
                    nome: `${element.numeroContrato} - ${element.nomeContrato}`,
                    ativo: element.numeroContratoAtivo,
                })).filter((element) => element.ativo === true)
                .filter((element) => element.codigo !== dataActiveContract.numero);

            const responseDadosContrato = await buscaDadosPorContrato(numeroContrato);
            const dadosContrato = responseDadosContrato.results;
    
            setDataForm({ ...dataForm, novoContrato: [...dadosContrato] });

            setTreatedResponseGrupoContratos(responseGrupoContratos);

            let results;

            if (residencial?.ufAtendimento && residencial?.codigoMunicipioAtendimento) {
                results = await getCongenerByContractAndPlanAndUfAndCity({
                    numeroContrato: dataActiveContract?.numero,
                    codigoPlano: responseBeneficiarioTransferencia?.plano?.codigo,
                    siglaUf: residencial?.ufAtendimento,
                    codigoMunicipio: residencial?.codigoMunicipioAtendimento,
                });
            } else {
                results = await getCongenerByContractAndPlan({
                    numeroContrato: dataActiveContract?.numero,
                    codigoPlano: responseBeneficiarioTransferencia?.plano?.codigo,
                });
            }

            if (results?.results?.length) results = results.results;

            const [{ nomeFantasiaCongenere }] = results?.length ? results : [{ nomeFantasiaCongenere: '' }];

            setDataCongener({ ...dataCongener, actual: nomeFantasiaCongenere });

            if (dataForm.novoContrato.value) {
                const contractFound = responseGrupoContratos.find(
                    (contract) => contract.parametros.codigoTsContrato === +dataForm.novoContrato.value
                );

                if (contractFound) dataForm.novoContrato.value = contractFound.codigo;
            }

            const initialValues = {
                ...cloneObject(dataForm),
                novaMatricula: {
                    ...dataForm.novaMatricula,
                    value: dataForm.novaMatricula.value || responseBeneficiarioTransferencia?.numMatriculaEmpresa,
                },
                dataTransferencia: {
                    ...dataForm.dataTransferencia,
                    value:
                        dataForm.dataTransferencia.value || moment(referenciaMovimentacao.dataReferenciaMovimentacao),
                },
                novoContrato: {
                    ...dataForm.novoContrato,
                    options: responseGrupoContratos,
                },
            };

            checkTransferDate(initialValues);

            setDataForm(initialValues);

            setBeneficiario({ ...responseBeneficiarioTransferencia });

            setSuggertedTransferDate(moment(referenciaMovimentacao.dataReferenciaMovimentacao));

            setDataContrato({ ...dataActiveContract });
            setPageLoading(false);
        }

        loadDataBeneficiario();
    }, []);

    return (
        <PageContainer>
            <StepProgress steps={steps.transferirBeneficiario} activeStep={2} />

            {alerts.map((alert, index) => (
                <Alert key={() => index} type={alert.tipo} title={alert.descricao} message={alert.complemento} />
            ))}

            <Accordion title="Transferir beneficiário" hasCollapse={false}>
                <FormContainer>
                    <Input
                        field={{
                            id: 'cpf',
                            label: 'CPF',
                            value: addMaskCpf(beneficiario?.cpf),
                            disabled: true,
                        }}
                    />

                    <Input
                        field={{
                            id: 'carteirinha',
                            label: 'N° da carteirinha',
                            value: beneficiario?.carteirinha,
                            disabled: true,
                        }}
                    />

                    <Input
                        field={{
                            id: 'nomeCompleto',
                            label: 'Nome completo',
                            value: beneficiario?.nomeCompleto,
                            disabled: true,
                        }}
                    />

                    <Input
                        field={{
                            id: 'contratoAtual',
                            label: 'Contrato atual',
                            value: dataContrato?.numero ? `${dataContrato?.numero} - ${dataContrato?.nome}` : '',
                            disabled: true,
                        }}
                    />

                    <Input
                        field={{
                            id: 'planoAtual',
                            label: 'Plano atual',
                            value: beneficiario?.plano?.nome,
                            disabled: true,
                        }}
                    />
                    <Input
                        field={{
                            id: 'stateService',
                            label: 'Estado de atendimento',
                            value: residencial?.ufAtendimento,
                            lookup: residencial?.ufAtendimento,
                            disabled: true,
                        }}
                    />
                    <Input
                        field={{
                            id: 'countyService',
                            label: 'Municipio de atendimento',
                            value: residencial?.nomeMunicipioAtendimento,
                            lookup: residencial?.nomeMunicipioAtendimento,
                            disabled: true,
                        }}
                    />
                    <Input
                        field={{
                            label: 'Congênere',
                            value: dataCongener?.actual,
                            disabled: true,
                        }}
                    />
                </FormContainer>

                <Divider />

                <FormContainer>
                    <Datepicker
                        field={dataForm.dataTransferencia}
                        onBlur={handleInputBlur}
                        onChange={handleChangeInput}
                    />
                    <Select field={dataForm.novoContrato} onBlur={handleInputBlur} onChange={handleChangeInput} />

                    <Select
                        id="novaLotacao"
                        field={{
                            ...dataForm.novaLotacao,
                            disabled: !dataForm.novoContrato?.value,
                        }}
                        onBlur={handleInputBlur}
                        onChange={handleChangeInput}
                    />

                    {!(dataActiveContract.isPme && dataActiveContract.isHealth) && (
                        <Select
                            field={{
                                ...dataForm.novoCentroCusto,
                                disabled: !dataForm.novoContrato?.value,
                            }}
                            onBlur={handleInputBlur}
                            onChange={handleChangeInput}
                        />
                    )}

                    <Select
                        field={{
                            ...dataForm.novoPlano,
                            disabled: !dataForm.novoContrato.value,
                        }}
                        onBlur={handleInputBlur}
                        onChange={handleChangeInput}
                    />

                    <Input field={dataForm.novaMatricula} onChange={handleChangeInput} onBlur={handleInputBlur} />

                    <Select
                        field={{
                            ...dataForm.state,
                            disabled: !dataForm.novoContrato.value || !dataForm.novoPlano.value,
                        }}
                        onChange={handleChangeInput}
                    />

                    <Select
                        field={{
                            ...dataForm.city,
                            disabled: !dataForm.state.value && !dataForm.city.value,
                        }}
                        onChange={handleChangeInput}
                    />

                    {dataCongener?.new && (
                        <Input
                            field={{
                                label: 'Congênere',
                                value: dataCongener?.new,
                                disabled: true,
                            }}
                        />
                    )}

                    {allowedPlans.dependente && (
                        <Select
                            field={{
                                ...dataForm.novoPlanoDependente,
                                disabled: !dataForm.novoContrato.value,
                            }}
                            onBlur={handleInputBlur}
                            onChange={handleChangeInput}
                        />
                    )}

                    {allowedPlans.agregado && (
                        <Select
                            field={{
                                ...dataForm.novoPlanoAgregado,
                                disabled: !dataForm.novoContrato.value,
                            }}
                            onBlur={handleInputBlur}
                            onChange={handleChangeInput}
                        />
                    )}
                </FormContainer>
            </Accordion>

            {beneficiario?.dependentes?.length > 0 && <DependentsDetails dataBeneficiario={beneficiario} />}
            <ContainerButton>
                <Button id="backStep" type="secondary" onClick={() => history.goBack()}>
                    Voltar
                </Button>

                <Button
                    id="continueStep"
                    type="primary"
                    loading={loadingPost}
                    disabled={loadingPost}
                    onClick={handleSendTransferencia}
                >
                    Finalizar
                </Button>
            </ContainerButton>

            <Modal
                title={modalInfo.title}
                visible={showModal}
                subtitle={modalInfo.message}
                onCancel={() => setShowModal(false)}
                footer={null}
            >
                {!modalInfo.backButton ? (
                    <>
                        <Button
                            type="secondary"
                            onClick={() => {
                                setDataForm({
                                    ...dataForm,
                                    dataTransferencia: {
                                        ...dataForm.dataTransferencia,
                                        error: '',
                                        value: suggestedTransferDate,
                                    },
                                });

                                setAlreadyChangedTransferDate(false);
                                setShowModal(false);
                            }}
                        >
                            Não quero
                        </Button>

                        <Button onClick={() => setShowModal(false)}>Sim, quero</Button>
                    </>
                ) : (
                    <Button onClick={() => setShowModal(false)}>Tudo bem</Button>
                )}
            </Modal>
            <PageLoader loading={pageLoading} />
            <Modal
                title="Atenção"
                subtitle={modalMessage}
                visible={showModal}
                onCancel={() => setShowModal(false)}
                footer={null}
            >
                <Button
                    type="primary"
                    onClick={() => {
                        setShowModal(false);
                    }}
                >
                    Entendi
                </Button>
            </Modal>
        </PageContainer>
    );
}

export default Beneficiario;
